/**
 * 계약 상수
 */
export const ContractConst = {
  //----------------------------------
  // 공통
  //----------------------------------
  // 접근형태
  accessType: {
    MY: "my",
    COMPANY: "company",
    DEFAULT: "default",
  },
  // 수정 형태
  modifyType: {
    CREATE: "등록",
    UPDATE: "수정",
  },
  // 통신 형태
  signalType: {
    CREATE: 0,
    UPDATE: 1,
  },
  //----------------------------------
  // 화면 변수
  //----------------------------------
  // 진행 상태
  progressStatus: {
    REQUEST: "요청",
    DESIGNING_ESTIMATING: "설계/견적중",
    COMPLETED: "완료",
    STOPPED: "중단",
  },
  // 농업인경영체 등록여부
  agriRegistered: {
    REGISTER: "등록",
    UNREGISTER: "미등록",
  },
  //----------------------------------
  // 데이터 변수
  //----------------------------------
} as const;
